import { FC } from 'react';
import { Loader2 } from 'lucide-react';

export const ExtractionLoader: FC = () => (
  <div className="flex flex-col items-center justify-center gap-4 py-12 text-center">
    <Loader2 className="size-8 animate-spin text-(--primary-O900)" />
    <p className="[font-size:var(--fs-p3)]! text-(--neutral-black-NB700)!">
      Reading your transcript… this can take up to a minute.
    </p>
  </div>
);
